import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import MembersItemBlockData from 'app/Models/Content/MembersItemBlockData';
import React from 'react';
import {isMobile} from 'react-device-detect';
import MemberItemBlock from './MemberItemBlock';
import TagName from 'app/Components/Shared/TagName';

const MembersItemBlock = ({data, context}: ComponentProps<MembersItemBlockData>) => {
  return (
    <div className='MembersItemBlock'>
      {!isMobile && <MemberItemBlock data={data} context={context} />}
      {isMobile && <MemberItemBlock data={data} context={context} />}

      <div className='MembersItemBlock__title-and-subtitle'>
        <TagName className='MembersItemBlock__title-and-subtitle__title' isTitle tagName={data?.titleHeadlineTag?.value}>
          {data?.title?.value}
        </TagName>

        <span className='MembersItemBlock__title-and-subtitle__subtitle'>{data?.subTitle?.value}</span>
      </div>
    </div>
  );
};

export default MembersItemBlock;
